/**
 * Notification Types
 *
 * Shared types for the notification feature — used by frontend and backend.
 */
export var NotificationType;
(function (NotificationType) {
    NotificationType["APPLICATION_UPDATE"] = "APPLICATION_UPDATE";
    NotificationType["INTERVIEW_SCHEDULED"] = "INTERVIEW_SCHEDULED";
    NotificationType["INTERVIEW_REMINDER"] = "INTERVIEW_REMINDER";
    NotificationType["MESSAGE_RECEIVED"] = "MESSAGE_RECEIVED";
    NotificationType["AI_INSIGHT_READY"] = "AI_INSIGHT_READY";
    NotificationType["PLACEMENT_DRIVE_ANNOUNCED"] = "PLACEMENT_DRIVE_ANNOUNCED";
    NotificationType["ASSESSMENT_ASSIGNED"] = "ASSESSMENT_ASSIGNED";
    NotificationType["OFFER_RECEIVED"] = "OFFER_RECEIVED";
    NotificationType["OFFER_ACCEPTED"] = "OFFER_ACCEPTED";
    NotificationType["OFFER_REJECTED"] = "OFFER_REJECTED";
    NotificationType["RESUME_REVIEWED"] = "RESUME_REVIEWED";
    NotificationType["PROFILE_VERIFIED"] = "PROFILE_VERIFIED";
    NotificationType["ORG_JOIN_APPROVED"] = "ORG_JOIN_APPROVED";
    NotificationType["ORG_JOIN_REJECTED"] = "ORG_JOIN_REJECTED";
    NotificationType["CREDIT_LOW"] = "CREDIT_LOW";
    NotificationType["CONNECTION_REQUEST_RECEIVED"] = "CONNECTION_REQUEST_RECEIVED";
    NotificationType["CONNECTION_REQUEST_ACCEPTED"] = "CONNECTION_REQUEST_ACCEPTED";
    NotificationType["RECOGNITION_REQUESTED"] = "RECOGNITION_REQUESTED";
    NotificationType["NOTICE_POSTED"] = "NOTICE_POSTED";
    NotificationType["DRIVE_UPDATE"] = "DRIVE_UPDATE";
    NotificationType["OPT_OUT_REVIEWED"] = "OPT_OUT_REVIEWED";
    NotificationType["DOCUMENT_REQUESTED"] = "DOCUMENT_REQUESTED";
    NotificationType["DOCUMENT_REVIEWED"] = "DOCUMENT_REVIEWED";
    NotificationType["SYSTEM"] = "SYSTEM";
})(NotificationType || (NotificationType = {}));
export const NOTIFICATION_CATEGORIES = [
    {
        key: 'APPLICATIONS',
        label: 'Applications & offers',
        description: 'Status changes, interviews and offers on jobs you applied to.',
    },
    { key: 'MESSAGES', label: 'Messages', description: 'New messages in your inbox.' },
    {
        key: 'NETWORK',
        label: 'Connections',
        description: 'Connection requests, acceptances and skill recognition requests.',
    },
    {
        key: 'COLLEGE',
        label: 'Your college',
        description: 'Notices, campus drives, assigned assessments, document requests and resume reviews.',
    },
];
export const DEFAULT_NOTIFICATION_PREFERENCES = {
    APPLICATIONS: { inApp: true, email: true },
    MESSAGES: { inApp: true, email: false },
    NETWORK: { inApp: true, email: false },
    COLLEGE: { inApp: true, email: true },
};
const CATEGORY_OF = {
    APPLICATION_UPDATE: 'APPLICATIONS',
    INTERVIEW_SCHEDULED: 'APPLICATIONS',
    INTERVIEW_REMINDER: 'APPLICATIONS',
    OFFER_RECEIVED: 'APPLICATIONS',
    OFFER_ACCEPTED: 'APPLICATIONS',
    OFFER_REJECTED: 'APPLICATIONS',
    MESSAGE_RECEIVED: 'MESSAGES',
    CONNECTION_REQUEST_RECEIVED: 'NETWORK',
    CONNECTION_REQUEST_ACCEPTED: 'NETWORK',
    RECOGNITION_REQUESTED: 'NETWORK',
    NOTICE_POSTED: 'COLLEGE',
    PLACEMENT_DRIVE_ANNOUNCED: 'COLLEGE',
    DRIVE_UPDATE: 'COLLEGE',
    OPT_OUT_REVIEWED: 'COLLEGE',
    ASSESSMENT_ASSIGNED: 'COLLEGE',
    DOCUMENT_REQUESTED: 'COLLEGE',
    DOCUMENT_REVIEWED: 'COLLEGE',
    RESUME_REVIEWED: 'COLLEGE',
    ORG_JOIN_APPROVED: 'COLLEGE',
    ORG_JOIN_REJECTED: 'COLLEGE',
};
/**
 * The category a notification type belongs to, or null for account and
 * security notices, which can't be switched off.
 */
export function notificationCategory(type) {
    return CATEGORY_OF[type] ?? null;
}
/** Stored preferences merged over the defaults (missing categories use the default). */
export function resolveNotificationPreferences(stored) {
    const out = { ...DEFAULT_NOTIFICATION_PREFERENCES };
    for (const { key } of NOTIFICATION_CATEGORIES) {
        const s = stored?.[key];
        if (s) {
            out[key] = {
                inApp: typeof s.inApp === 'boolean' ? s.inApp : out[key].inApp,
                email: typeof s.email === 'boolean' ? s.email : out[key].email,
            };
        }
    }
    return out;
}
